export interface LoadingStateInterface {
  executions: boolean;
  boards: boolean;
  postings: boolean;
  statistics: boolean;
  tasks: boolean;
  users: boolean;
}

export default function (): LoadingStateInterface {
  return {
    executions: true,
    boards: true,
    statistics: true,
    postings: false,
    tasks: false,
    users: false,
  };
}
